<template lang="pug">
	.asset-video-generation(v-if="showed && creative" v-window :class="{collapsed}")
		.card-wrapper(:style="{transform: collapsed ? `translate(calc(-50vw + 50% + 58px), ${(Layout.headerHeight + Layout.subHeaderHeight) / 2}px)` : 'translate(0px, 0px)'}")
			.card(:style="{transform: `translate(${dragPosition[0]}px, ${dragPosition[1]}px), scale(${metadata.hiding ? 0.9 : 1})`}")
				.card-header
					i.fa.fa-film
					span AI Video Generation
					button.btn.btn-sm.btn-outline-primary.collapse-left(type="button" @click="toggle()" v-b-tooltip.hover="{delay: { show: 500, hide: 100, zIndex: 5000}, title: 'Collapse left to fast switch between several videos'}")
						.fa(:class="collapsed ? 'fa-angle-double-right' : 'fa-angle-double-left'")
				.card-body.collapse.show
					.form-line.description
						span.text-muted Here you can generate a new video using a text prompt, or animate an attached image (image to video).
					.form-line.generations.separator(@wheel="scrollVariations($event)")
						.variation-list(ref="generation-list" @scroll="updateScrollTrack()" :style="{height: collapsed ? `calc(100vh - 262px)` : '137px'}")
							.variation(v-for="variation in variations" :class="{[variation.status]: true}")
								.variation-link
									.button(@click="openVariation(variation)") {{variation.type.toUpperCase()}}
								.variation-status.status-prepare(v-if="variation.status === 'prepare'") Waiting...
								.variation-status.status-upload(v-else-if="variation.status === 'upload'") Upload...
								.variation-status.status-generate(v-else-if="variation.status === 'generate'") Generating...
								.variation-status.status-download(v-else-if="variation.status === 'download'") Download...
								.variation-status.status-error(v-else-if="variation.status === 'error'") Error
								.variation-status.status-completed(v-else-if="variation.status === 'completed'")
									.videos
										.video(v-for="video in variation['videos']" :class="{attached: attachments[video.videoId] === true, selected: !!video.selected}" @click="collapsed ? applyAsset(variation, video) : openVideoInfo(variation, video)")
											video(:src="video.path" muted preload="metadata" loop playsinline)
											.apply-variation(v-if="!collapsed && !video.selected" @click.stop="applyAsset(variation, video)") Apply variation
											.reset-variation(v-if="!collapsed && video.selected && canRevertVideo(video)" @click.stop="revertVideo()") Reset variation
											.view-video(v-if="collapsed" @click.stop="openVideoInfo(variation, video)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'View video'}")
												.fa.fa-arrows-alt
											.attach-video(@click.stop="attachVideo(variation, video)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Attach video frame as start frame reference for image to video'}")
												.fa.fa-paperclip
											.revert-video(v-if="collapsed && video.selected && canRevertVideo(video)" @click.stop="revertVideo()" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Return original video'}")
												.fa.fa-close
							.variation-list-scroll(:class="{['is-scrolling']: isScrolling}")
								.variation-list-thrumb(v-show="isOverflow" :style="{width: scrollWidth + 'px', left: scrollLeft + 'px', height: scrollHeight + 'px', top: scrollTop + 'px'}")
					.collapsing-form
						AssetVideoGenerationSettings(ref="settings" :creative="creative" :asset="asset" @change="updateSettings($event)")
					.form-actions
						.collapsing-buttons
							button.btn.btn-primary(type="button" @click="generate()" :disabled="!settings.prompt")
								i.fa.fa-film
								span(v-if="settings.prompt") Generate {{settings.count > 1 ? settings.count : ''}} {{settings.count > 1 ? 'videos' : 'video'}}{{_.size(attachments) > 0 ? ' from the start frame' : ''}}
								span(v-else) Please type a prompt
						button.upload-video.btn.btn-outline-secondary(type="button" @click="uploadVideo($event)")
							i.fa.fa-upload
							span Upload video
						button.available-budget.btn.btn-link(v-if="Creative.getAvailableAIBudget(creative)" type="button" @click="showCreativeAISettings()")
							span Available budget: {{Creative.getAvailableAIBudgetDescription(creative)}}
						button.btn.btn-dark.right-button(type="button" @click="closeWindow()") Close
</template>

<script>

	import Screen 								from '../../mixins/screen'

	import AssetVideoGenerationSettings			from './AssetVideoGenerationSettings'

	export default {
		name: "AssetVideoGeneration",
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Creative Generations Loaded",
				"Selected Creative Generation Added",
				"Selected Creative Generation Changed: [status]",
				"Selected Creative Generation Removed",
				"Selected Creative Asset Uploads Loaded",
				"Selected Creative Asset Upload Added",
				"Selected Creative Asset Upload Removed",
				"Selected Creative Updated",
				"Creative AI Budget Changed", // для изменения доступного ИИ бюджета
				"Publishers Changed",
				"Selected Version Assets Changed"
			],
			events: {
				"Show AssetVideoGeneration": function(asset, options) {

					this.asset = asset;

					// Ассета может не быть (генерация с нуля) - работаем в указанной версии, ассет создаётся при первой генерации
					if (asset) this.versionId = asset['version_id'];
					else this.versionId = options?.versionId;

					// Окно открыто из списка элементов: при первой генерации вместе с ассетом создаётся и элемент
					this.elementOptions = options?.newElementType ? {
						newElementType: options.newElementType,
						elementScreenCodename: options.elementScreenCodename,
						parentElementId: options.parentElementId
					} : null;

					this.pendingAssetCodename = null;

					this.creative = Creative.SelectedCreative;

					this.update();

					Server.sendToSocket({
						Navigation: {
							title: 'Page',
							description: 'asset-video-generation',
							data: {}
						}
					});

				},
				"AssetVideoGeneration Hided": function() {

					this.collapsed = false;

				}
			}
		},
		components: {
			AssetVideoGenerationSettings
		},
		data() {

			this.variations = [];

			this.creative = null;
			this.asset = null;

			// Генерация с нуля: версия, в которой создаётся ассет, данные для создания элемента
			// (если окно открыто из списка элементов) и codename ожидаемого нового ассета
			this.versionId = null;
			this.elementOptions = null;
			this.pendingAssetCodename = null;

			return {
				metadata: {hiding: false}, // нужно продублировать это из window директивы так как оно используется и в этом компоненте тоже
				attachments: {},
				settings: {},
				isOverflow: false,
				isScrolling: false,
				scrollWidth: 100,
				scrollLeft: 0,
				scrollHeight: 100,
				scrollTop: 0,
				collapsed: false
			}

		},
		methods: {
			collectData(eventName, ...params) {

				if (!this.creative) return;

				if (Creative.getCreative(this.creative.id)) this.creative = Creative.getCreative(this.creative.id);

				// Генерация с нуля: ассет создаётся на сервере при первой генерации - подхватываем его из изменившихся ассетов
				if (!this.asset && eventName === "Selected Version Assets Changed") this.adoptGeneratedAsset(params);

				this.variations = [];

				let generations = Asset.getCreativeGenerations(this.creative.id),
					uploads = Asset.getCreativeAssetUploads(this.creative.id);

				if (this.asset) {

					this.asset = Asset.getAsset(Version.getVersion(this.asset['version_id']), this.asset.codename);

					_.each(generations, generation => {

						if (generation['asset_codename'] === this.asset.codename) {

							this.variations.push({
								type: "generation",
								status: generation.status,
								videos: _.map(generation["result_images"], video => {
									return {
										path: `generations/${video.fileName}`,
										fileName: video.fileName,
										videoId: `generation-${generation.id}-image-${video.vendorId}`,
										selected: (this.asset.options?.replacedFrom?.assetGenerationId === generation.id && this.asset.options?.replacedFrom?.fileName === video.fileName) || (this.asset.url.indexOf('generations/') > 0 && this.asset.url.indexOf(video.fileName) > 0)
									}
								}),
								timestamp: generation["start_time"].getTime(),
								generation
							});

						}

					});

					_.each(uploads, upload => {

						if (upload['asset_codename'] === this.asset.codename) {

							this.variations.push({
								type: "upload",
								status: "completed",
								videos: [{
									path: `project-assets/project-${upload["creative_id"]}/version-${upload["version_id"]}/${upload["file_name"]}`,
									fileName: upload["file_name"],
									videoId: `upload-${upload.id}`,
									selected: this.asset.options?.replacedFrom?.assetUploadId === upload.id || (this.asset.url.indexOf('project-assets/') > 0 && this.asset.url.indexOf(upload["file_name"]) > 0)
								}],
								timestamp: upload["date"].getTime(),
								upload
							});

						}

					});

					this.variations = _.orderBy(this.variations, "timestamp", "desc");

					let originalAssetUrl = Asset.getAssetOriginalUrl(this.asset);

					if (originalAssetUrl) {

						this.variations.push({
							type: "original", status: "completed", videos: [{
								path: originalAssetUrl,
								fileName: this.asset.codename,
								videoId: `original-${this.asset.codename}`,
								selected: !Asset.AssetsByVersionByCodename[this.asset['version_id']]?.[this.asset.codename]?.url
							}]
						});

					}

				}

				this.$nextTick(() => {

					this.updateScrollTrack();

					if (this.$refs["settings"]) this.$refs["settings"].update();

				});

			},
			// Генерация с нуля: подхватывает ассет, созданный сервером при первой генерации
			// (changedAssets - пары [versionId, codename] из события "Selected Version Assets Changed")
			adoptGeneratedAsset(changedAssets) {

				if (!this.pendingAssetCodename) return;

				let version = Version.getVersion(this.versionId);

				if (!version) return;

				let assetCodename = _.find(_.map(_.filter(changedAssets, changed => changed[0] === this.versionId), '1'), codename => Asset.getAsset(version, codename)?.type === 'video'),
					asset = assetCodename ? Asset.getAsset(version, assetCodename) : null;

				if (!asset) return;

				this.asset = asset;
				this.pendingAssetCodename = null;

			},
			toggle() {

				this.collapsed = !this.collapsed;

				this.updateScrollTrack();

				this.$nextTick(() => {
					this.updateScrollTrack();
				});

				setTimeout(() => {

					this.updateScrollTrack();

				}, 210);

			},
			openVariation(variation) {

				if (variation.type === "generation") Broadcast.call("Show AssetVideoGenerationInfo", [variation, variation.generation, this.asset]);
				else if (variation.type === "upload") Broadcast.call("Show AssetVideoUploadInfo", [variation, variation.upload, this.asset]);
				else if (variation.type === "original") Broadcast.call("Show AssetVideoOriginalInfo", [variation, this.asset]);

			},
			// Прикрепление видео-кадра как референса (start frame) для генерации image to video
			attachVideo(variation, video) {

				if (this.attachments[video.videoId]) delete this.attachments[video.videoId];
				else this.attachments[video.videoId] = true;

				this.update();

				if (this.$refs["settings"]) this.$refs["settings"].setAttachmentsCount(_.size(this.attachments));

			},
			// Сбросить вариацию можно только если сейчас установлена не самая старая вариация
			canRevertVideo(video) {

				let originalVariation = this.getOriginalVariation();

				return !!originalVariation && originalVariation.videos[0].videoId !== video.videoId;

			},
			revertVideo() {

				let originalVariation = this.getOriginalVariation();

				if (!originalVariation) return;

				this.applyAsset(originalVariation, originalVariation.videos[0]);

			},
			// Самая старая по времени добавления готовая вариация (original, upload или generation) - на неё производится сброс.
			// Вариации отсортированы от новых к старым, original всегда в конце списка
			getOriginalVariation() {

				return _.findLast(this.variations, variation => variation.status === "completed" && _.size(variation.videos) > 0);

			},
			applyAsset(variation, video) {

				if (variation.type === "generation") {

					Server.sendToServer({
						ApplyAssetGeneration: {
							assetGenerationId: variation.generation.id,
							fileName: video.fileName
						}
					});

				} else if (variation.type === "upload") {

					Server.sendToServer({
						ApplyAssetUpload: {
							assetUploadId: variation.upload.id
						}
					});

				} else if (variation.type === "original") {

					Server.sendToServer({
						ResetAssetUrl: {
							versionId: this.asset['version_id'],
							assetCodename: this.asset.codename
						}
					});

				}

			},
			openVideoInfo(variation, video) {

				Broadcast.call("Show AssetVideoInfo", [this.creative, this.asset, variation, video]);

			},
			scrollVariations(e) {

				if (e.deltaY !== 0) {

					e.preventDefault();

					if (this.collapsed) {

						this.$refs["generation-list"].scrollTop += e.deltaY * 3;

					} else {

						this.$refs["generation-list"].scrollLeft += e.deltaY * 3;

					}

					this.isScrolling = true;

					clearTimeout(this.scrollingTimeout);
					this.scrollingTimeout = setTimeout(() => {

						this.isScrolling = false;

					}, 600);

				}

			},
			updateScrollTrack() {

				if (this.$refs["generation-list"].scrollHeight > this.$refs["generation-list"].clientHeight && this.collapsed) {

					this.isOverflow = true;

					this.scrollWidth = 8;
					this.scrollLeft = 0;

					this.scrollHeight = (this.$refs["generation-list"].clientHeight / this.$refs["generation-list"].scrollHeight) * this.$refs["generation-list"].clientHeight;
					this.scrollTop = (this.$refs["generation-list"].scrollTop / (this.$refs["generation-list"].scrollHeight - this.$refs["generation-list"].clientHeight)) * (this.$refs["generation-list"].clientHeight - this.scrollHeight);

				} else if (this.$refs["generation-list"].scrollWidth > this.$refs["generation-list"].clientWidth && !this.collapsed) {

					this.isOverflow = true;

					this.scrollHeight = 8;
					this.scrollTop = 0;

					this.scrollWidth = (this.$refs["generation-list"].clientWidth / this.$refs["generation-list"].scrollWidth) * this.$refs["generation-list"].clientWidth;
					this.scrollLeft = (this.$refs["generation-list"].scrollLeft / (this.$refs["generation-list"].scrollWidth - this.$refs["generation-list"].clientWidth)) * (this.$refs["generation-list"].clientWidth - this.scrollWidth);

				} else {

					this.isOverflow = false;

				}

			},
			updateSettings(settings) {

				this.settings = settings;

			},
			generate() {

				let settings = this.$refs["settings"].getSettings();

				// Генерация с нуля: ассета ещё нет - сервер создаст его (и элемент, если окно открыто из списка элементов)
				// при первой генерации. Запоминаем codename, чтобы подхватить созданный ассет
				if (!this.asset) this.pendingAssetCodename = this.getGeneratedAssetCodename(settings.prompt);

				Server.sendToServer({
					GenerateVideo: {
						versionId: this.versionId,
						assetCodename: this.asset ? this.asset['codename'] : '',
						aiVendorCodename: settings.vendorCodename,
						aiModelCodename: settings.modelCodename,
						aiSizeCodename: settings.sizeCodename,
						duration: settings.duration,
						prompt: settings.prompt,
						attachments: Object.keys(this.attachments),
						count: settings.count,
						newAssetCodename: this.pendingAssetCodename ? this.pendingAssetCodename : '',
						newElementType: this.elementOptions ? this.elementOptions.newElementType : '',
						elementScreenCodename: this.elementOptions ? this.elementOptions.elementScreenCodename : '',
						elementId: this.elementOptions ? this.elementOptions.parentElementId : 0
					}
				});

				this.attachments = {};

				this.update();

				if (this.$refs["settings"]) this.$refs["settings"].setAttachmentsCount(_.size(this.attachments));

			},
			// codename нового ассета при генерации с нуля - по промпту (как у ИИ агента); уникальность обеспечивает сервер
			getGeneratedAssetCodename(prompt) {

				return _.trim(_.kebabCase(prompt).substring(0, 60), '-') || 'ai-video';

			},
			uploadVideo() {

				Asset.requestFile('video/mp4', file => {

					Asset.uploadAsset(this.asset, file);

				});

			},
			showCreativeAISettings() {

				Broadcast.call("Show CreativeSettingsAI");

			}
		}
	}
</script>

<style lang="sass">

	.asset-video-generation
		display: flex
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card-wrapper
			display: flex
			margin: auto
			transition: 0.3s

		.card-header

			.collapse-left
				margin-left: auto

				.fa
					font-size: 18px
					margin-top: 4px
					margin-bottom: 3px
					width: 15px

		.card
			width: 1000px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			button
				white-space: nowrap

				i
					margin-right: 10px

			.btn-ghost-dark, .btn-dark
				color: #fff

		.description
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 10px

		.form-line
			display: flex
			flex-direction: row

		.generations
			flex-direction: column

			.variation-list
				display: flex
				flex-direction: row
				overflow-x: auto
				scrollbar-width: none
				-ms-overflow-style: none
				scroll-behavior: smooth

				&::-webkit-scrollbar
					display: none

			.variation
				flex-shrink: 0
				display: flex
				flex-direction: column
				margin-right: 10px

				.variation-link
					display: flex

					.button
						cursor: pointer
						font-size: 11px
						color: var(--gray)
						letter-spacing: 1px

				.variation-status
					display: flex
					align-items: center
					justify-content: center
					height: 110px
					min-width: 160px
					font-size: 12px
					color: var(--gray)

					&.status-error
						color: var(--red)

				.status-completed
					height: auto

				.videos
					display: flex
					flex-direction: row
					align-items: center

				.video
					position: relative
					flex-shrink: 0
					width: 160px
					height: 110px
					border-radius: 5px
					overflow: hidden
					border: 2px solid var(--gray-dark)
					background-color: #000
					cursor: pointer
					margin-left: 10px

					&:hover
						border-color: var(--primary)

					video
						width: 100%
						height: 100%
						object-fit: cover
						pointer-events: none

					.apply-variation, .reset-variation
						display: none
						position: absolute
						left: 0
						right: 0
						bottom: 0
						justify-content: center
						background-color: rgba(0,0,0,0.6)
						color: #fff
						font-size: 11px
						padding: 4px 0

					.view-video, .attach-video, .revert-video
						display: flex
						position: absolute
						top: 4px
						font-size: 14px
						color: #fff
						opacity: 0.6

					.view-video
						right: 4px

					.attach-video
						left: 4px

					.revert-video
						right: 4px
						display: none

					&:hover
						.apply-variation, .reset-variation
							display: flex

				.video:first-child
					margin-left: 0

				.video.selected
					border-color: var(--green)

					.revert-video
						display: flex

				.video.attached
					border-color: var(--orange)

					.attach-video
						color: var(--orange)
						opacity: 1

		.collapsing-form
			height: 200px
			transition: 0.3s

		.form-actions
			display: flex
			flex-direction: row
			align-items: center
			margin-top: 20px

			.collapsing-buttons
				display: flex
				flex-direction: row
				align-items: center

			.available-budget
				margin-left: 20px
				white-space: nowrap

			.right-button
				margin-left: auto

			.upload-video
				margin-left: 20px

	.asset-video-generation.collapsed
		background-color: transparent
		pointer-events: none !important
		user-select: none

		.card
			width: 251px
			pointer-events: all
			box-shadow: none
			transform: none !important

		.generations
			flex-direction: row

			.variation-list
				flex-direction: column
				overflow-y: auto
				overflow-x: hidden

				.variation
					margin-right: 0
					margin-bottom: 10px

					.variation-status
						height: auto

			.videos
				flex-direction: column
				align-items: center

			.video
				width: 200px
				height: 140px
				margin-left: 0
				margin-top: 10px

				.attach-video
					display: none

			.video:first-child
				margin-top: 0

		.collapsing-form
			height: 0
			overflow: hidden

		.description
			height: 0
			margin-bottom: 0
			padding-bottom: 0
			border: 0
			overflow: hidden

		.form-actions
			margin-top: 10px
			justify-content: center

			.collapsing-buttons
				display: none

			.right-button
				margin-left: inherit

</style>

